import React, { useEffect } from "react";
import { useSessionDetailContext } from "../../hooks/useSessionDetail";
import { Icon, Typography } from "../../common/MaterialComponent";
import "./UserProfile.css";
import { SessionDetail } from "../../common/interfaces";

export const UserProfile = () => {
	const contextSessionDetail: SessionDetail = useSessionDetailContext()
		.sessionDetail;
	const [sessionDetail, setSessionDetail] = React.useState<SessionDetail>(
		contextSessionDetail
	);

	useEffect(() => {
		setSessionDetail(contextSessionDetail);
	}, [contextSessionDetail]);

	return (
		<>
			<div className="userProfile">
				{sessionDetail && sessionDetail.accessToken && sessionDetail.userInfo && (
					<>
						<div>
							<Icon color="primary" fontSize="large" className="profileIcon">
								account_circle
							</Icon>
							<Typography component="span" variant="h6" className="userName">
								{sessionDetail.userInfo ? sessionDetail.userInfo.name : ""}
							</Typography>
						</div>
					</>
				)}
			</div>
		</>
	);
};
